import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { Viewports } from '../../../../../play-core/styles/Viewports';
export const ImageContainer = styled.div.withConfig({
  displayName: "DetailContentstyles__ImageContainer",
  componentId: "sc-707dfw-0"
})(["width:250px;min-width:250px;margin-right:32px;", "{width:100%;}"], Viewports.for('small'));
export const Layout = styled.div.withConfig({
  displayName: "DetailContentstyles__Layout",
  componentId: "sc-707dfw-1"
})(["display:flex;flex-direction:row;", "{flex-direction:column;}"], Viewports.for('small'));
export const DescriptionLayout = styled.div.withConfig({
  displayName: "DetailContentstyles__DescriptionLayout",
  componentId: "sc-707dfw-2"
})(["display:flex;flex-direction:column;padding-bottom:24px;max-width:780px;", "{padding:16px;}"], Viewports.for('small'));
export const Title = styled.h2.withConfig({
  displayName: "DetailContentstyles__Title",
  componentId: "sc-707dfw-3"
})(["margin:0 0 8px 0;color:", ";", ";", "{", ";}"], Colors.WHITE, Fonts.medium(34), Viewports.for('small'), Fonts.medium(24));
export const SubTitle = styled.h3.withConfig({
  displayName: "DetailContentstyles__SubTitle",
  componentId: "sc-707dfw-4"
})(["margin:12px 0;color:", ";", ";", "{margin:4px 0;}"], Colors.GREY_d2d2d2, Fonts.regular(18), Viewports.for('small'));
export const MetaInfo = styled.div.withConfig({
  displayName: "DetailContentstyles__MetaInfo",
  componentId: "sc-707dfw-5"
})(["margin:8px 0;display:grid;grid-auto-flow:column;grid-template-columns:minmax(0,max-content);grid-column-gap:8px;", "{grid-auto-flow:row;align-items:start;}"], Viewports.for('small'));
export const MetaInfoLabels = styled.div.withConfig({
  displayName: "DetailContentstyles__MetaInfoLabels",
  componentId: "sc-707dfw-6"
})(["display:flex;flex-wrap:wrap;align-items:center;color:", ";", ";line-height:24px;", "{margin:8px 0;}"], Colors.GREY_d2d2d2, Fonts.regular(16), Viewports.for('small'));
export const ChannelLogo = styled.img.withConfig({
  displayName: "DetailContentstyles__ChannelLogo",
  componentId: "sc-707dfw-7"
})(["height:25px;"]);
export const BroadcastInfo = styled.div.withConfig({
  displayName: "DetailContentstyles__BroadcastInfo",
  componentId: "sc-707dfw-8"
})(["margin:12px 0;display:grid;grid-auto-flow:column;color:", ";", ";align-items:center;grid-gap:8px;align-self:flex-start;"], Colors.GREY_969696, Fonts.regular(16));
export const Lead = styled.p.withConfig({
  displayName: "DetailContentstyles__Lead",
  componentId: "sc-707dfw-9"
})(["color:", ";", ";line-height:28px;", "{", ";line-height:24px;}"], Colors.GREY_d2d2d2, Fonts.regular(18), Viewports.for('small'), Fonts.regular(18));
export const Description = styled.p.withConfig({
  displayName: "DetailContentstyles__Description",
  componentId: "sc-707dfw-10"
})(["color:", ";", ";line-height:28px;", "{", ";line-height:24px;}"], Colors.GREY_d2d2d2, Fonts.light(18), Viewports.for('small'), Fonts.light(18));
export const CreditTitle = styled.h4.withConfig({
  displayName: "DetailContentstyles__CreditTitle",
  componentId: "sc-707dfw-11"
})(["margin:16px 0 8px;color:", ";", ";"], Colors.GREY_d2d2d2, Fonts.regular(24));
export const CreditList = styled.ul.withConfig({
  displayName: "DetailContentstyles__CreditList",
  componentId: "sc-707dfw-12"
})([""]);
export const CreditItem = styled.li.withConfig({
  displayName: "DetailContentstyles__CreditItem",
  componentId: "sc-707dfw-13"
})(["color:", ";", ";line-height:28px;"], Colors.GREY_d2d2d2, Fonts.light(18));
export const HeadlineTitle = styled.p.withConfig({
  displayName: "DetailContentstyles__HeadlineTitle",
  componentId: "sc-707dfw-14"
})(["margin:28px 0 8px;color:", ";", ";"], Colors.GREY_d2d2d2, Fonts.regular(18));
export const HeadlineDescription = styled.p.withConfig({
  displayName: "DetailContentstyles__HeadlineDescription",
  componentId: "sc-707dfw-15"
})(["margin:4px 0;color:", ";", ";line-height:28px;", "{line-height:24px;}"], Colors.GREY_d2d2d2, Fonts.light(18), Viewports.for('small'));